import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import logo from '../images/sslmo-logo.png';
import {
  HeaderContainer,
  HeaderContent,
  NavLinks,
  NavLink,
  Logo,
  NavRight,
  CTAButton
} from './Header.styled';

import { ContactModal } from './ContactModal';

const Header: React.FC = () => {
  const location = useLocation();
  const [isContactOpen, setIsContactOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <NavLinks>
          <NavLink to="/" className={isActive('/')}>서비스 소개</NavLink>
          <NavLink to="/news" className={isActive('/news')}>언론보도</NavLink>
          <NavLink to="/pricing" className={isActive('/pricing')}>가격 안내</NavLink>
          <NavLink to="/blog" className={isActive('/blog')}>블로그</NavLink>
        </NavLinks>
        
        <Logo to="/">
          <img src={logo} alt="쓸모 로고" />
        </Logo>
        
        <NavRight>
          <NavLink to="/sslmo/login" className={isActive('/sslmo')}>로그인</NavLink>
          <CTAButton href="#" onClick={(e) => { e.preventDefault(); localStorage.setItem('cta_source', 'header_cta'); setIsContactOpen(true); }}>도입 문의하기</CTAButton>
        </NavRight>
      </HeaderContent>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} initialSource="header_cta" />
    </HeaderContainer>
  );
};

export default Header;